import FormatValue from 'assets/components/formatValue/FormatValue';
import Icon from 'assets/components/icon/Icon';
import { getLocales } from 'assets/locales/Locale';
import Sidebar from 'assets/templates/sidebar/Sidebar';
import { defaultDateTimeFormat, localizeDate } from 'assets/utils/data/Date';
import PaymentType from 'models/enums/PaymentType';
import { useContractRefundPaymentProvider } from '../Finance.ContractRefundPayment.Hooks';

export default function ContractRefundPaymentInfo() {
  const { lang, translate } = getLocales();
  const { selected, pageRouter } = useContractRefundPaymentProvider();

  if (!selected || pageRouter.params?.action !== 'info') return null;

  return (
    <Sidebar
      onClose={() => pageRouter.updateParams({})}
      icon={<Icon class="if-database" />}
      title={selected.referenceNumber}
      content={
        <>
          <h3>{lang.info}</h3>
          <div>
            {lang.referenceNumber}: <b>{selected.referenceNumber}</b>
          </div>
          <div>
            {lang.owner}: <b>{selected.owner?.fullName ?? 'N/A'}</b>
          </div>
          <div>
            {lang.paymentAt}:{' '}
            <b>{selected.createdAtLocal ? localizeDate(selected?.createdAtLocal, defaultDateTimeFormat) : 'N/A'}</b>
          </div>

          <h3>{lang.payee}</h3>
          <div>
            {lang.payeeName}: <b>{selected.contractRefundPaymentPayee?.displayInfo?.title ?? 'N/A'}</b>
          </div>
          <div>
            {lang.address}: <b>{selected.contractRefundPaymentPayee?.fullAddress ?? 'N/A'}</b>
          </div>
          <div>
            {lang.city}: <b>{selected.contractRefundPaymentPayee?.addressDetails?.city ?? 'N/A'}</b>
          </div>
          <div>
            {lang.province}: <b>{selected.contractRefundPaymentPayee?.addressDetails?.province ?? 'N/A'}</b>
          </div>
          <div>
            {lang.postalCode}: <b>{selected.contractRefundPaymentPayee?.addressDetails?.postalCode ?? 'N/A'}</b>
          </div>

          <h3>{lang.prices}</h3>
          <div>
            {lang.paidAmount}:{' '}
            <b>
              <FormatValue value={`${(selected.amountPaid || 0).toFixed(2)}$`} />
            </b>
          </div>
          <div>
            {selected.currency === 'CAD' ? lang.gstHstPaid : lang.tax}:{' '}
            <b>
              <FormatValue value={`${(selected.gstHstAmountPaid || 0).toFixed(2)}$`} />
            </b>
          </div>
          {selected.currency === 'CAD' && (
            <div>
              {lang.pstPaid}:{' '}
              <b>
                <FormatValue value={`${(selected.provincialSalesTaxAmountPaid || 0).toFixed(2)}$`} />
              </b>
            </div>
          )}
          <div>
            {lang.totalPaid}:{' '}
            <b>
              <FormatValue value={`${(selected.totalPaidAmt || 0).toFixed(2)}$`} />
            </b>
          </div>

          <h3>{lang.items}</h3>
          {selected.contractRefundPaymentItems?.map((item, idx) => (
            <div key={'contractRefundPaymentItem_' + item.id}>
              <div>
                {lang.item}: <b>{`${item.jobId}-I${idx + 1}`}</b>
              </div>
              <div>
                {lang.itemTotal}:{' '}
                <b>
                  <FormatValue value={`${(item.totalAmount || 0).toFixed(2)}$`} />
                </b>
              </div>
              <br />
            </div>
          ))}
          <div>
            {lang.totalItems}: <b>{selected.numberOfItems ?? selected.contractRefundPaymentItems?.length ?? 0}</b>
          </div>
          <div>
            {lang.totalPaid}:{' '}
            <b>
              <FormatValue value={`${(selected.totalPaidAmt || 0).toFixed(2)}$`} />
            </b>
          </div>

          <h3>{lang.payment}</h3>
          <div>
            {lang.paymentMethod}: <b>{selected.paymentMethodCode ? translate(selected.paymentMethodCode) : 'N/A'}</b>
          </div>

          <h3>{lang.paymentInfoDetails}</h3>
          <div>
            {lang.paymentUser}: <b>{selected.owner?.fullName ?? 'N/A'}</b>
          </div>
          <div>
            {lang.transactionDate}: <b>{localizeDate(selected.transactionDateUtc, defaultDateTimeFormat) ?? 'N/A'}</b>
          </div>
          {selected.paymentMethodCode === PaymentType.eft && (
            <>
              <div>
                {lang.bankTransit}: <b>{selected.bankTransit ?? 'N/A'}</b>
              </div>
              <div>
                {lang.bankBranch}: <b>{selected.bankBranch ?? 'N/A'}</b>
              </div>
              <div>
                {lang.bankAccount}: <b>{selected.bankAccount ?? 'N/A'}</b>
              </div>
              <div>
                {lang.remittanceEmailAddress}: <b>{selected.remittanceEmailAddress ?? 'N/A'}</b>
              </div>
            </>
          )}
          {selected.paymentMethodCode === PaymentType.cheque && (
            <>
              <div>
                {lang.chequeNumber}: <b>{selected.chequeNumber ?? 'N/A'}</b>
              </div>
              <div>
                {lang.remittanceEmailAddress}: <b>{selected.remittanceEmailAddress ?? 'N/A'}</b>
              </div>
            </>
          )}
          {(selected.paymentMethodCode === PaymentType.ETransfer ||
            selected.paymentMethodCode === PaymentType.usBank) && (
            <>
              {selected.paymentMethodCode === PaymentType.ETransfer && (
                <>
                  <div>
                    {lang.transactionNumber}: <b>{selected.transactionNumber ?? 'N/A'}</b>
                  </div>
                  <div>
                    {lang.eTransferQuestion}: <b>{selected.eTransferQuestion ?? 'N/A'}</b>
                  </div>
                  <div>
                    {lang.eTransferAnswer}: <b>{selected.eTransferAnswer ?? 'N/A'}</b>
                  </div>
                </>
              )}
              <div>
                {lang.paymentEmailAddress}: <b>{selected.paymentEmailAddress ?? 'N/A'}</b>
              </div>
              <div>
                {lang.remittanceEmailAddress}: <b>{selected.remittanceEmailAddress ?? 'N/A'}</b>
              </div>
            </>
          )}
          <div>
            {lang.explanation}: <b>{selected.explanation || 'N/A'}</b>
          </div>
        </>
      }
    />
  );
}
